import React, { useEffect, useState } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import "./recentBlogs.css";

const RecentBlogs = () => {
  const [recentEvents, setRecentEvents] = useState([]);

  useEffect(() => {
    fetchRecentEvents();
  }, []);

  const fetchRecentEvents = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/events`);
      // Sort by newest first and limit to 5
      const sorted = data
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0, 5);
      setRecentEvents(sorted);
    } catch (error) {
      console.error("Error fetching recent events:", error);
    }
  };

  return (
    <div id="recent-sidebar-container">
      <h1 className="recent-events">Recent Events</h1>

      <div id="recent-card-grid">
        {recentEvents.length === 0 ? (
          <p className="no-events-msg">No recent events available.</p>
        ) : (
          recentEvents.map((event) => (
            <div className="recent-card" key={event._id}>
              <div className="image-wrapper-recent-blog">
                <img
                  src={event.image}
                  alt={event.title}
                  loading="lazy"
                />
              </div>

              <h3>{event.title}</h3>
              <p>{event.shortDescription?.slice(0, 120)}...</p>
              <p className="created-date">
                🗓️{" "}
                <b>
                  {new Date(event.createdAt).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </b>
              </p>

              <NavLink to={`/event/${event._id}`} className="no-underline">
                <button className="read-more-btn">READ MORE</button>
              </NavLink>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RecentBlogs;
